import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { formatFechaHora } from '../../utils/format';

// ============================================================
// Encabezado que solo sale al imprimir o guardar como PDF (#115): título,
// empresa activa, detalle (filtros, moneda) y fecha de impresión. Va una vez
// por reporte, arriba del contenido; la cabecera de pantalla lleva
// `print:hidden`.
// ============================================================

export default function EncabezadoImpresion({ titulo, detalle }) {
  const { empresaActivaNombre } = useAuth();
  return (
    <div className="hidden print:block mb-3">
      <h1 className="text-xl font-bold">{titulo}{empresaActivaNombre ? ` · ${empresaActivaNombre}` : ''}</h1>
      <p className="text-sm">
        {detalle ? `${detalle} · ` : ''}Impreso el {formatFechaHora(new Date().toISOString())}
      </p>
    </div>
  );
}
